/**
 * Traducción display-only de epígrafes PyG.
 * Las claves internas / cálculos siguen en español (PGC/NPGC).
 */

function normalizePygTitle(s) {
  return String(s || "")
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\.+$/, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

const PYG_LINE_BY_NORMALIZED = {};

const addLine = (es, key) => {
  PYG_LINE_BY_NORMALIZED[normalizePygTitle(es)] = key;
};

addLine("1. Importe neto de la cifra de negocios.", "netRevenue");
addLine(
  "2. Variación de existencias de productos terminados y en curso de fabricación.",
  "inventoryChange",
);
addLine("2. Variación de existencias.", "inventoryChange");
addLine(
  "3. Trabajos realizados por la empresa para su activo.",
  "ownWorkCapitalised",
);
addLine("4. Aprovisionamientos.", "supplies");
addLine("5. Otros ingresos de explotación.", "otherOperatingIncome");
addLine("6. Gastos de personal.", "staffCosts");
addLine("a) Sueldos, salarios y asimilados.", "wages");
addLine("b) Cargas sociales.", "socialCharges");
addLine("c) Provisiones.", "provisions");
addLine("7. Otros gastos de explotación.", "otherOperatingExpenses");
addLine("8. Amortización del inmovilizado.", "depreciation");
addLine(
  "9. Imputación de subvenciones de inmovilizado no financiero y otras.",
  "grantsReleased",
);
addLine("10. Excesos de provisiones.", "excessProvisions");
addLine(
  "11. Deterioro y resultado por enajenaciones del inmovilizado.",
  "impairmentDisposalsFixed",
);
addLine(
  "12. Diferencia negativa de combinaciones de negocio.",
  "bargainPurchase",
);
addLine("13. Otros resultados.", "otherResults");
addLine("14. Ingresos financieros.", "financialIncome");
addLine("15. Gastos financieros.", "financialExpenses");
addLine(
  "16. Variación de valor razonable en instrumentos financieros.",
  "fairValueInstruments",
);
addLine("17. Diferencias de cambio.", "exchangeDifferences");
addLine(
  "18. Deterioro y resultado por enajenaciones de instrumentos financieros.",
  "impairmentDisposalsFinancial",
);
addLine("19. Impuestos sobre beneficios.", "incomeTax");
addLine(
  "20. Resultado del ejercicio procedente de operaciones interrumpidas neto de impuestos.",
  "discontinuedOperations",
);
addLine(
  "22 c) Pérdidas, deterioro y variación de provisiones por operaciones comerciales.",
  "commercialProvisions",
);
addLine("A.1) RESULTADO DE EXPLOTACIÓN", "operatingResult");
addLine("A.2) RESULTADO FINANCIERO", "financialResult");
addLine("A.3) RESULTADO ANTES DE IMPUESTOS", "resultBeforeTax");
addLine(
  "A.4) RESULTADO DEL EJERCICIO PROCEDENTE DE OPERACIONES",
  "resultFromOperations",
);
addLine(
  "A.4) RESULTADO DEL EJERCICIO PROCEDENTE DE OPERACIONES CONTINUADAS",
  "resultFromContinuing",
);
addLine("A.5) RESULTADO DEL EJERCICIO", "resultForTheYear");
addLine("RESULTADO FINAL", "finalResult");
addLine("PROYECCIÓN VENTAS", "salesProjection");
addLine("PROYECCIÓN COMPRAS", "purchaseProjection");
addLine("PEDIDOS VENTA", "openSalesOrders");
addLine("PEDIDOS DE VENTA", "openSalesOrders");
addLine("PEDIDOS COMPRA", "openPurchaseOrders");
addLine("PEDIDOS DE COMPRA", "openPurchaseOrders");
addLine("FACTURAS BORRADOR VENTA", "draftSalesInvoices");
addLine("GASTOS DE PERSONAL", "staffCostsGroup");
addLine("OTROS GASTOS DE GESTIÓN", "otherManagementExpenses");
addLine("CONSUMO DE MERCADERÍAS", "merchandiseConsumption");
addLine("a) Consumo de mercaderías", "merchandiseConsumption");
addLine("A) ACTIVO NO CORRIENTE", "nonCurrentAssets");
addLine("B) ACTIVO CORRIENTE", "currentAssets");
addLine("TOTAL ACTIVO", "totalAssets");
addLine("A) PATRIMONIO NETO", "equity");
addLine("B) PASIVO NO CORRIENTE", "nonCurrentLiabilities");
addLine("C) PASIVO CORRIENTE", "currentLiabilities");
addLine("TOTAL PATRIMONIO NETO Y PASIVO", "totalEquityAndLiabilities");
addLine("I. Inmovilizado intangible", "intangibleAssets");
addLine("1. Desarrollo", "development");
addLine("2. Concesiones", "concessions");
addLine("3. Patentes, licencias, marcas y similares", "patentsLicences");
addLine("4. Fondo de comercio", "goodwill");
addLine("5. Aplicaciones informáticas", "computerSoftware");
addLine("6. Investigación", "research");
addLine("7. Otro inmovilizado intangible", "otherIntangible");
addLine("II. Inmovilizado material", "propertyPlantEquipment");
addLine("1. Terrenos y construcciones", "landAndBuildings");
addLine(
  "2. Instalaciones técnicas y otro inmovilizado material",
  "plantAndOtherPpe",
);
addLine("3. Inmovilizado en curso y anticipos", "ppeUnderConstruction");
addLine("III. Inversiones inmobiliarias", "investmentProperty");
addLine("1. Terrenos", "land");
addLine("2. Construcciones", "buildings");
addLine(
  "IV. Inversiones en empresas del grupo y asociadas a largo plazo",
  "groupInvestmentsLt",
);
addLine("1. Instrumentos de patrimonio", "equityInstruments");
addLine("2. Créditos a empresas", "loansToCompanies");
addLine("2. Créditos a terceros", "loansToThirdParties");
addLine("3. Valores representativos de deuda", "debtSecurities");
addLine("4. Derivados", "derivatives");
addLine("5. Otros activos financieros", "otherFinancialAssets");
addLine("6. Otras inversiones", "otherInvestments");
addLine("V. Inversiones financieras a largo plazo", "financialInvestmentsLt");
addLine("VI. Activos por impuesto diferido", "deferredTaxAssets");
addLine("VII. Deudas comerciales no corrientes", "nonCurrentTradeDebts");
addLine("I. Activos no corrientes mantenidos para la venta", "ncaHeldForSale");
addLine("II. Existencias", "inventories");
addLine("1. Comerciales", "merchandise");
addLine("2. Materias primas y otros aprovisionamientos", "rawMaterials");
addLine("3. Productos en curso", "workInProgress");
addLine("a) De ciclo largo de producción", "longProductionCycle");
addLine("b) De ciclo corto de producción", "shortProductionCycle");
addLine("4. Productos terminados", "finishedGoods");
addLine("5. Subproductos, residuos y materiales recuperados", "byProducts");
addLine("6. Anticipos a proveedores", "advancesToSuppliers");
addLine(
  "III. Deudores comerciales y otras cuentas a cobrar",
  "tradeAndOtherReceivables",
);
addLine(
  "1. Clientes por ventas y prestaciones de servicios",
  "tradeReceivables",
);
addLine(
  "a) Clientes por ventas y prestaciones de servicios a largo plazo",
  "tradeReceivablesLt",
);
addLine(
  "b) Clientes por ventas y prestaciones de servicios a corto plazo",
  "tradeReceivablesSt",
);
addLine("2. Clientes, empresas del grupo y asociadas", "groupTradeReceivables");
addLine("3. Deudores varios", "otherReceivables");
addLine("4. Personal", "personnel");
addLine("5. Activos por impuesto corriente", "currentTaxAssets");
addLine(
  "6. Otros créditos con las Administraciones Públicas",
  "otherPublicAdminReceivables",
);
addLine(
  "7. Accionistas (socios) por desembolsos exigidos",
  "calledUpShareCapital",
);
addLine(
  "IV. Inversiones en empresas del grupo y asociadas a corto plazo",
  "groupInvestmentsSt",
);
addLine("V. Inversiones financieras a corto plazo", "financialInvestmentsSt");
addLine("VI. Periodificaciones a corto plazo", "shortTermPrepayments");
addLine(
  "VII. Efectivo y otros activos líquidos equivalentes",
  "cashAndEquivalents",
);
addLine("1. Tesorería", "cash");
addLine("2. Otros activos líquidos equivalentes", "otherCashEquivalents");
addLine("A-1) Fondos propios", "equityFunds");
addLine("I. Capital", "shareCapital");
addLine("1. Capital escriturado", "registeredCapital");
addLine("2. (Capital no exigido)", "uncalledCapital");
addLine("II. Prima de emisión", "sharePremium");
addLine("III. Reservas", "reserves");
addLine("1. Legal y estatutarias", "legalReserves");
addLine("2. Otras reservas", "otherReserves");
addLine(
  "IV. (Acciones y participaciones en patrimonio propias)",
  "treasuryShares",
);
addLine("V. Resultados de ejercicios anteriores", "priorYearResults");
addLine("1. Remanente", "retainedEarnings");
addLine(
  "2. (Resultados negativos de ejercicios anteriores)",
  "priorYearLosses",
);
addLine("VI. Otras aportaciones de socios", "otherShareholderContributions");
addLine("VII. Resultado del ejercicio", "profitForTheYearBs");
addLine("VIII. (Dividendo a cuenta)", "interimDividend");
addLine("IX. Otros instrumentos de patrimonio neto", "otherEquityInstruments");
addLine("A-2) Ajustes por cambios de valor", "valuationAdjustments");
addLine(
  "I. Activos financieros disponibles para la venta",
  "afsFinancialAssets",
);
addLine("II. Operaciones de cobertura", "hedgingOperations");
addLine(
  "III. Activos no corrientes y pasivos vinculados, mantenidos para la venta",
  "hfsLinked",
);
addLine("IV. Diferencia de conversión", "translationDifferences");
addLine("V. Otros", "otherItems");
addLine(
  "A-3) Subvenciones, donaciones y legados recibidos",
  "grantsAndDonations",
);
addLine("I. Provisiones a largo plazo", "longTermProvisions");
addLine(
  "1. Obligaciones por prestaciones a largo plazo al personal",
  "longTermStaffBenefits",
);
addLine("2. Actuaciones medioambientales", "environmentalActions");
addLine("3. Provisiones por reestructuración", "restructuringProvisions");
addLine("4. Otras provisiones", "otherProvisions");
addLine("II. Deudas a largo plazo", "longTermDebts");
addLine("1. Obligaciones y otros valores negociables", "bondsAndSecurities");
addLine("2. Deuda con entidades de crédito", "bankBorrowings");
addLine("3. Acreedores por arrendamiento financiero", "financeLeasePayables");
addLine("5. Otros pasivos financieros", "otherFinancialLiabilities");
addLine(
  "III. Deudas con empresas del grupo y asociadas a largo plazo",
  "groupDebtsLt",
);
addLine("IV. Pasivos por impuesto diferido", "deferredTaxLiabilities");
addLine("V. Periodificaciones a largo plazo", "longTermAccruals");
addLine("VI. Acreedores comerciales no corrientes", "nonCurrentTradePayables");
addLine(
  "VII. Deuda con características especiales a largo plazo",
  "specialDebtsLt",
);
addLine(
  "I. Pasivos vinculados con activos no corrientes mantenidos para la venta",
  "hfsLiabilities",
);
addLine("II. Provisiones a corto plazo", "shortTermProvisions");
addLine("III. Deudas a corto plazo", "shortTermDebts");
addLine(
  "IV. Deudas con empresas del grupo y asociadas a corto plazo",
  "groupDebtsSt",
);
addLine(
  "V. Acreedores comerciales y otras cuentas a pagar",
  "tradeAndOtherPayables",
);
addLine("1. Proveedores", "suppliers");
addLine("a) Proveedores a largo plazo", "suppliersLt");
addLine("b) Proveedores a corto plazo", "suppliersSt");
addLine("2. Proveedores, empresas del grupo y asociadas", "groupSuppliers");
addLine("3. Acreedores varios", "otherPayables");
addLine("4. Personal (remuneraciones pendientes de pago)", "personnelPayables");
addLine("5. Pasivos por impuesto corriente", "currentTaxLiabilities");
addLine(
  "6. Otras deudas con las Administraciones Públicas",
  "otherPublicAdminPayables",
);
addLine("7. Anticipos de clientes", "customerAdvances");

export const MARCA_REASON_I18N = {
  "Resultado positivo": "positiveResult",
  "Pérdida contable pero con pedidos fuertes": "lossWithStrongOrders",
  "Resultado negativo": "negativeResult",
  "Margen sólido s/ venta": "solidMargin",
  "Pipeline de pedidos venta": "salesPipeline",
  "Volumen bajo": "lowVolume",
};

export function pygLineI18nKey(titulo) {
  const core = String(titulo || "").trim();
  if (!core) return null;
  const key = PYG_LINE_BY_NORMALIZED[normalizePygTitle(core)];
  return key ? `pygAnalitico.lines.${key}` : null;
}

/** Conserva sangría de Excel/tabla. Si no hay diccionario, deja el español. */
export function translatePygLine(t, titulo) {
  const raw = String(titulo ?? "");
  const lead = raw.match(/^\s*/)?.[0] || "";
  const core = raw.trim();
  if (!core) return raw;
  if (typeof t !== "function") return raw;
  const i18nKey = pygLineI18nKey(core);
  if (!i18nKey) return raw;
  return lead + t(i18nKey, { defaultValue: core });
}

export function translateMarcaReason(t, reason) {
  const key = MARCA_REASON_I18N[reason];
  if (!key || typeof t !== "function") return reason;
  return t(`pygAnalitico.reason.${key}`, { defaultValue: reason });
}

export function pygVistaLabelKey(vistaValue) {
  return `pygAnalitico.vista.${vistaValue}`;
}

export function pygFiltroResumenKey(vistaValue) {
  return `pygAnalitico.filtro.${vistaValue}`;
}

export function pygPriorityLabel(t, prioridad, fallback) {
  if (!prioridad) return fallback || "—";
  if (typeof t !== "function") return fallback || prioridad;
  return t(`pygAnalitico.priority.${prioridad}`, {
    defaultValue: fallback || prioridad,
  });
}

/** Opciones i18n para Excel (cabeceras + epígrafes). */
export function pygExcelI18nOpts(t) {
  if (typeof t !== "function") return {};
  return {
    translateTitle: (s) => translatePygLine(t, s),
    titleHeader: t("pygAnalitico.titleCol"),
    totalHeader: t("pygAnalitico.total"),
  };
}
